import { render, staticRenderFns } from "./Recommender.vue?vue&type=template&id=c6aa98ee&scoped=true"
import script from "./Recommender.vue?vue&type=script&lang=js"
export * from "./Recommender.vue?vue&type=script&lang=js"
import style0 from "./Recommender.vue?vue&type=style&index=0&id=c6aa98ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6aa98ee",
  null
  
)

export default component.exports